import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Tooltip,
    Typography,
} from "@material-ui/core";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import PermDeviceInformationIcon from "@material-ui/icons/PermDeviceInformation";
import { useTranslation } from "react-i18next";

// Define the prop types for the component
interface FindCircuitsPopupProps {
    buttonClassName: string; // Explicitly define the type for buttonClassName
    buttonStyle: React.CSSProperties; // Explicitly define the type for buttonStyle
}

const FindCircuitsPopup: React.FC<FindCircuitsPopupProps> = ({ buttonClassName, buttonStyle }) => {
    const { t } = useTranslation<'common'>();
    const [open, setOpen] = useState(false);

    const togglePopup = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                onClick={togglePopup}
                className={buttonClassName}
                style={{ background: "#25d366", color: "white", ...buttonStyle }}
            >
                {t("detail-annonce.callUs")}
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{t("label.contactezNous")}</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item md={12} lg={12} sm={12} xs={12}>
                            <span
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "black",
                                    display: "flex",
                                    alignItems: "flex-start",
                                }}
                            >
                                {t("detail-annonce.bookOnPhone")}
                                <Tooltip
                                    title={
                                        <>
                                            <Typography variant="body1">
                                                {t("detail-annonce.bookOnPhone")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {t("detail-annonce.hoverTextPhone")}
                                            </Typography>
                                        </>
                                    }
                                >
                                    <PermDeviceInformationIcon
                                        style={{
                                            marginLeft: "4px",
                                            color: "#890608",
                                            verticalAlign: "bottom",
                                        }}
                                    />
                                </Tooltip>
                            </span>
                        </Grid>
                    </Grid>
                    <Grid
                        style={{
                            padding: 12,
                            marginTop: 0,
                            lineHeight: "25px",
                            color: "black",
                        }}
                    >
                        <div
                            className="text_body"
                            style={{
                                fontWeight: "normal",
                                textAlign: "center",
                                lineHeight: "1.5",
                            }}
                        >
                            {t("detail-annonce.contactServiceClient")}
                            <br />
                            <span className="phoneNumber">
                                <WhatsAppIcon
                                    style={{
                                        verticalAlign: "middle",
                                        color: "#890608",
                                        marginRight: "8px",
                                    }}
                                />
                                <a
                                    href="whatsapp://send?phone=+237655959595"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {t("detail-annonce.numéro1")}
                                </a>
                            </span>
                            <br />
                            <span className="phoneNumber">
                                <WhatsAppIcon
                                    style={{
                                        verticalAlign: "middle",
                                        color: "#890608",
                                        marginRight: "8px",
                                    }}
                                />
                                <a
                                    href="whatsapp://send?phone=+237659797979"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {t("detail-annonce.numéro2")}
                                </a>
                            </span>
                        </div>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t("label.fermer")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default FindCircuitsPopup;